import React from 'react';
import { Box, Typography } from '@mui/material';

const STATUS_CONFIG = {
  draft:    { bg: '#f8fafc', color: '#475569', dot: '#94a3b8' },
  pending:  { bg: '#fffbeb', color: '#92400e', dot: '#f59e0b' },
  approved: { bg: '#f0fdf4', color: '#15803d', dot: '#22c55e' },
  rejected: { bg: '#fef2f2', color: '#dc2626', dot: '#ef4444' },
};

const PENDING_ACTION_LABEL = {
  edit:    'Edit Pending',
  delete:  'Delete Pending',
  convert: 'Convert Pending',
};

export default function ApprovalStatusBadge({ status, actionType }) {
  const key = status?.toLowerCase() ?? 'draft';
  const cfg = STATUS_CONFIG[key] ?? STATUS_CONFIG.draft;
  const label =
    key === 'pending' && PENDING_ACTION_LABEL[actionType?.toLowerCase()]
      ? PENDING_ACTION_LABEL[actionType.toLowerCase()]
      : key.charAt(0).toUpperCase() + key.slice(1);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.45,
        borderRadius: '20px',
        bgcolor: cfg.bg,
        border: `1px solid ${cfg.dot}33`,
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: cfg.dot, flexShrink: 0 }} />
      <Typography sx={{ fontSize: '0.6875rem', fontWeight: 700, color: cfg.color, lineHeight: 1, letterSpacing: '0.2px', whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
    </Box>
  );
}
